import { useMemo } from 'react';
import Items, { defaultConfigComponent as ItemsConfig } from '../Items/Items';
import { IConfigComponent } from '@ts/ui-models';
import { CPerson } from '@ts/ui-models';

export const defaultConfigComponent = (): IConfigComponent => {
  return {
    ...ItemsConfig,
    componentId: 'people',
    entity: 'person',
    filtersFetchData: { person: { isAlive: true } },
    mainClass: CPerson,
  };
};

const People = props => {
  const defaultConfig = useMemo(() => defaultConfigComponent(), []);

  const defaultProps = {
    title: 'People',
    flavorId: 'person',
    nameColumns: ['defaultLocation', 'currentLocation', 'lastPosition'],
  };

  return <Items configComponent={defaultConfig} {...props} {...defaultProps} />;
};

export default People;
